<template>
  <header class="container-fluid">
    <div class="row">
      <div class="col-md-5 info-user">
        <p>
          Olá
          {{ getAccount.dependent.name }}
        </p>
        <p>Seu Saldo: R$ {{ parseFloat(getAccount.balance).toFixed(2) }}</p>
        <p>
          Limite Total :
          {{
            getAccount.daily_limit
              ? "R$ " + parseFloat(getAccount.daily_limit).toFixed(2)
              : " Sem Limite"
          }}
        </p>
        <p>
          Limite Disponível :
          {{
            getAccount.daily_limit
              ? "R$ " + parseFloat(getAccount.daily_limit_remaining).toFixed(2)
              : " Sem Limite"
          }}
        </p>
      </div>
      <div class="logo col-md-2 ">
        <img src="../assets/images/brand_01.png" alt="logo lanche bem" />
      </div>

      <div class="col-md-4 cart offset-1  ">
        <transition name="bounce">
          <p v-if="canShowCart">Total: R$ {{ getCart.amount.toFixed(2) }}</p>
        </transition>
      </div>
    </div>
  </header>
</template>

<script>
  import ShoppingCart from "../components/ShoppingCart";
  import { mapGetters } from "vuex";

  export default {
    name: "DefaultHeader",
    components: { ShoppingCart },
    computed: {
      ...mapGetters({ getAccount: "getAccount", getCart: "getCart" }),
    },

    data() {
      return {
        canShowCart: true,
      };
    },
    watch: {
      async "getCart.amount"(newCart, oldCart) {
        this.canShowCart = false;
        await sleep(10);
        this.canShowCart = true;
      },
    },
  };
</script>

<style>
  header {
    padding: 15px 15px 30px 15px;
    background-color: #f5e8d9;
  }

  .logo img {
    width: 100%;
  }

  .info-user {
    padding: 0;
    margin: 0;
  }

  .info-user > p {
    color: var(--dark-orange);
    font-size: 30px;
    font-weight: bold;
  }

  .cart {
    margin-top: 40px;
    padding: 15px;
    height: 100px;
    border-radius: 5px;
    background-color: var(--light-green);
    color: #fff;
  }

  .cart p {
    text-align: center;
    color: #ffffff;
    font-size: 50px;
    margin: 0;
  }
</style>
